module.exports = __webpack_public_path__ + "img/double222.7a67fc71.png";